import { MODAL_DATA_PARAM } from '../consts';

type GetModalDataOptions = {
  fallbackToRawString?: boolean;
};

export function getModalData(options?: GetModalDataOptions) {
  const raw = new URLSearchParams(window.location.search).get(MODAL_DATA_PARAM);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    if (options?.fallbackToRawString) {
      return raw;
    }

    return null;
  }
}
